export default __webpack_public_path__ + "static/media/Done.44dab9cf.svg";